module.exports = __webpack_public_path__ + "static/media/uploaded-docs-logo.1bfeb5b8.svg";